module.exports = __webpack_public_path__ + "assets/normal/images/day-header-calendar-icon.140bf8a4.png";